import fetch from 'isomorphic-unfetch';
import { setLoading } from 'store/app/actions';
import { store } from 'store/configureStore';
import { ParamsFetcher, ResponseFetcher } from 'utils/fetcher/types';
import { APP_CLIENT_ID, APP_CLIENT_SECRET } from 'variables';
import { SET_LOADING_HEADER_NAME } from './contants';
import { checkValidToken, logOut } from './tokenGuard';
import { getTokenRequest, setGettingToken } from 'store/oauth/actions';

const request: string[] = [];

export const paramsFormer = (requestBody: any) => {
  return Object.keys(requestBody)
    .map((key) => {
      return requestBody[key] !== undefined &&
        requestBody[key] !== null &&
        requestBody[key] !== '' &&
        requestBody[key] !== "''" &&
        requestBody[key].length !== 0 &&
        requestBody[key].toString()
        ? `${key}=${encodeURIComponent(requestBody[key])}`
        : `${key}`;
    })
    .join('&');
};

const fetcher = async ({
  url,
  options,
}: ParamsFetcher): Promise<ResponseFetcher<any>> => {
  const storeState = store.getState();
  const chkValidToken = checkValidToken(url);
  if (chkValidToken === 0) {
    logOut();
    return {
      ok: false,
      code: 401,
      url,
      data: {},
    };
  } else if (chkValidToken === 3 && !storeState.oauth.gettingToken) {
    store.dispatch(setGettingToken(true));
    // si el token debe renovarse (3 = token needs to renew), se solicita nuevo token
    // Si se esta solicitando ya otro token, no volvemos a solicitarlo para no entrar en loop
    store.dispatch(getTokenRequest());
  }
  const { headers, ...extraOptions } = options;

  // token
  const token = storeState.oauth.token;

  // Send request to stack if request has Set-Loading header
  if (headers?.[SET_LOADING_HEADER_NAME]) {
    request.push(url);

    // and show loading
    if (!storeState.app.loading) {
      store.dispatch(setLoading(true));
    }
  }

  // Headers have moved here, delete headers from requests
  const fetchOptions = {
    headers: {
      'Content-Type': 'application/json',
      ...headers,
      Authorization: token.access_token
        ? `${token.token_type} ${token.access_token}`
        : '',
      clientId: APP_CLIENT_ID,
      clientSecret: APP_CLIENT_SECRET,
    },
    ...extraOptions,
  };

  const res: Response = await fetch(url, fetchOptions);
  const code = res.status;
  const data = await res.json();

  // Remove request from requests stack
  if (headers?.[SET_LOADING_HEADER_NAME]) {
    const index = request.indexOf(url);
    request.splice(index, 1);

    // and hide loading if there isn't any request
    if (!request.length) {
      store.dispatch(setLoading(false));
    }
  }

  return {
    ok: res.ok,
    code,
    url,
    data,
  };
};

export default fetcher;
